import { BodyweightOnlyToggle } from "./BodyweightOnlyToggle";
import { MuscleCoverageCompactSection } from "./MuscleCoverageCompactSection";
import { noBodyweightMuscles, usePlanGapsCoverage } from "./planGaps";
import { todayGapsFromCoverage } from "./todayGapsFromCoverage";
import type { ProgressDeps } from "./types";

// The coverage census wired from a host's ProgressDeps: Progress mounts it at
// the top, the Home mounts it as a widget (HR-11). One wiring, two callsites.
export function MuscleCoverageCard({
  deps,
  locale,
}: {
  deps: ProgressDeps;
  locale: string;
}) {
  // `error` and `status` are read, not dropped: a failed read says so (PG-8),
  // and disk numbers the network has not confirmed are not final (PG-15).
  // #492 F5: the bodyweight toggle scopes the proposals the rows show too.
  const { coverage, results, catalog, error, status, bodyweightOnly, setBodyweightOnly } =
    usePlanGapsCoverage(deps);
  // AP-9b: only a host that can open the logger passes the handler, so a
  // coach never sees the link.
  const onBuildToday =
    deps.onBuildToday && catalog
      ? () => deps.onBuildToday?.(todayGapsFromCoverage(coverage), catalog, { bodyweightOnly })
      : undefined;
  return (
    <MuscleCoverageCompactSection
      theme={deps.theme}
      coverage={coverage}
      units={deps.units}
      locale={locale}
      figure={deps.figure}
      isDark={deps.isDark}
      loading={results === null || catalog === null}
      error={error}
      status={status}
      onBuildToday={onBuildToday}
      buildTodayExtra={
        <BodyweightOnlyToggle
          theme={deps.theme}
          value={bodyweightOnly}
          onValueChange={setBodyweightOnly}
          noBodyweight={noBodyweightMuscles(coverage)}
        />
      }
    />
  );
}
